import { faker } from '@faker-js/faker';

import { makeUser, type User } from '../models/user';

/** Options for creating mock users. */
export type CreateMockUsersOptions = Readonly<Partial<{

  /** Number of users to generate. */
  count: number;

  /** Seed value for deterministic generation. */
  seed: number;
}>>;

/**
 * Create mock users.
 * @param param0 Options for creating mock users.
 */
export function createMockUsers({ count = 20, seed = 2317 }: CreateMockUsersOptions = {}): readonly User[] {
  faker.seed(seed);
  return Array.from({ length: count }, () =>
    makeUser({
      id: faker.string.uuid(),
      firstName: faker.person.firstName(),
      secondName: faker.person.lastName(),
      dateOfBirth: faker.date.birthdate(),
      age: faker.number.int({ min: 20, max: 40 }),
    }));
}
